import { AfterViewInit, ChangeDetectorRef, Directive, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatSelect } from '@angular/material/select';

@Directive({
    selector: 'mat-select[fixValue]',
    standalone: true
})

export class MatSelectFixDirective implements AfterViewInit, OnChanges {
    private readonly matSelect = inject(MatSelect);
    private readonly cdr = inject(ChangeDetectorRef);

    @Input('fixValue') value: any;

    ngAfterViewInit() {
        this.updateValue();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['value'] && !changes['value'].firstChange) {
            this.updateValue();
        }
    }

    private updateValue() {
        setTimeout(() => {
            if (this.value !== undefined && this.value !== null) {
                this.matSelect.writeValue(this.value);
                this.cdr.markForCheck();

                setTimeout(() => {
                    this.cdr.detectChanges();
                });
            }
        }, 100);
    }
}